/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Types from '../../generated/types'

import { gql } from '@apollo/client'
import { PageFragmentDoc } from '../../ux/Page/Page.generated'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type PageQueryVariables = Types.Exact<{
  appId: Types.Scalars['ID']
  pageId: Types.Scalars['ID']
  projectId?: Types.InputMaybe<Types.Scalars['Int']>
  filters: Array<Types.FieldInput> | Types.FieldInput
  extraInputs: Array<Types.QueryInput> | Types.QueryInput
}>

export type PageQuery = {
  __typename?: 'Query'
  app?: {
    __typename?: 'App'
    id: string
    pageById?: {
      __typename?: 'Page'
      title?: string | null
      id: string
      background?: { __typename?: 'Background'; imageUrl?: string | null } | null
      banner?: { __typename?: 'Banner'; title?: string | null; subtitle?: string | null } | null
      link?:
        | { __typename?: 'ActionLink'; label?: string | null; action?: Types.Action | null }
        | { __typename?: 'ExternalLink'; label?: string | null; externalLink?: string | null }
        | {
            __typename?: 'NavLink'
            appId?: string | null
            label?: string | null
            projectId?: number | null
            pageId?: string | null
            setParams?: Array<{ __typename?: 'Param'; key: string; value?: string | null }> | null
            toggleParams?: Array<{ __typename?: 'Param'; key: string; value?: string | null }> | null
          }
        | null
      quickLinks?: {
        __typename?: 'QuickLinks'
        position?: Types.QuickLinksPosition | null
        links?: Array<{
          __typename?: 'QuickLink'
          title?: string | null
          description?: string | null
          imageUrl?: string | null
          navLink: {
            __typename?: 'NavLink'
            appId?: string | null
            label?: string | null
            projectId?: number | null
            pageId?: string | null
            setParams?: Array<{ __typename?: 'Param'; key: string; value?: string | null }> | null
            toggleParams?: Array<{ __typename?: 'Param'; key: string; value?: string | null }> | null
          }
        }> | null
      } | null
      panels: Array<{
        __typename?: 'Panel'
        title?: string | null
        collapsible?: boolean | null
        tiles: Array<{
          __typename?: 'Tile'
          title?: string | null
          collapsible?: boolean | null
          caption?: string | null
          allowContentCopy?: boolean | null
          allowContentDownload?: boolean | null
          filters: Array<
            | {
                __typename: 'BooleanField'
                id: string
                label?: string | null
                description?: string | null
                information?: string | null
                state?: boolean | null
                localEdited?: boolean | null
                localState?: boolean | null
              }
            | {
                __typename: 'DateField'
                id: string
                label?: string | null
                description?: string | null
                information?: string | null
                date?: any | null
                localEdited?: boolean | null
                localDate?: string | null
              }
            | {
                __typename: 'DateTimeField'
                id: string
                label?: string | null
                description?: string | null
                information?: string | null
                dateTime?: any | null
                localEdited?: boolean | null
                localDateTime?: string | null
              }
            | {
                __typename: 'DownloadFileField'
                id: string
                label?: string | null
                description?: string | null
                information?: string | null
                selection?: {
                  __typename?: 'SelectField'
                  style?: Types.SelectStyle | null
                  localEdited?: boolean | null
                  id: string
                  label?: string | null
                  description?: string | null
                  information?: string | null
                  options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
                  selection?: { __typename?: 'SelectOption'; label: string; value: string } | null
                  localSelection?: { __typename?: 'SelectOption'; label: string; value: string } | null
                } | null
              }
            | {
                __typename: 'MultiSelectField'
                id: string
                label?: string | null
                description?: string | null
                information?: string | null
                style?: Types.SelectStyle | null
                localEdited?: boolean | null
                options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
                selections?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
                localSelections?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
              }
            | {
                __typename: 'NumberField'
                id: string
                label?: string | null
                description?: string | null
                information?: string | null
                value?: number | null
                localEdited?: boolean | null
                localValue?: number | null
              }
            | {
                __typename: 'NumberRangeField'
                id: string
                label?: string | null
                description?: string | null
                information?: string | null
              }
            | {
                __typename: 'SelectField'
                id: string
                label?: string | null
                description?: string | null
                information?: string | null
                style?: Types.SelectStyle | null
                localEdited?: boolean | null
                options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
                selection?: { __typename?: 'SelectOption'; label: string; value: string } | null
                localSelection?: { __typename?: 'SelectOption'; label: string; value: string } | null
              }
            | {
                __typename: 'TextField'
                id: string
                label?: string | null
                description?: string | null
                information?: string | null
                text?: string | null
                localEdited?: boolean | null
                localText?: string | null
              }
            | {
                __typename: 'UploadFileField'
                id: string
                label?: string | null
                description?: string | null
                information?: string | null
                overrideAppId?: string | null
                templateId?: string | null
                entityId?: string | null
              }
          >
          shallowContent?:
            | { __typename?: 'Chart' }
            | { __typename?: 'DataTemplate' }
            | { __typename?: 'Form'; id: string }
            | { __typename?: 'Metric'; id: string }
            | { __typename?: 'Table'; id: string }
            | { __typename?: 'VegaLiteChart'; id: string }
            | null
        }>
      }>
      meta: {
        __typename?: 'Meta'
        label: string
        description?: string | null
        experimental: boolean
        allowPublicAccess: boolean
        requireSuperuser: boolean
        requireAdmin: boolean
        requireDeveloper: boolean
        requireInternal: boolean
      }
    } | null
  } | null
}

export type StaleIdsSubscriptionVariables = Types.Exact<{ [key: string]: never }>

export type StaleIdsSubscription = { __typename?: 'Subscription'; messages: string }

export const PageDocument = gql`
  query Page($appId: ID!, $pageId: ID!, $projectId: Int, $filters: [FieldInput!]!, $extraInputs: [QueryInput!]!) {
    app(id: $appId, projectId: $projectId, filters: $filters, extraInputs: $extraInputs) {
      id
      pageById(id: $pageId) {
        ...Page
      }
    }
  }
  ${PageFragmentDoc}
`

/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      appId: // value for 'appId'
 *      pageId: // value for 'pageId'
 *      projectId: // value for 'projectId'
 *      filters: // value for 'filters'
 *      extraInputs: // value for 'extraInputs'
 *   },
 * });
 */
export function usePageQuery(baseOptions: Apollo.QueryHookOptions<PageQuery, PageQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PageQuery, PageQueryVariables>(PageDocument, options)
}
export function usePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageQuery, PageQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PageQuery, PageQueryVariables>(PageDocument, options)
}
export type PageQueryHookResult = ReturnType<typeof usePageQuery>
export type PageLazyQueryHookResult = ReturnType<typeof usePageLazyQuery>
export type PageQueryResult = Apollo.QueryResult<PageQuery, PageQueryVariables>
export const StaleIdsDocument = gql`
  subscription StaleIds {
    messages
  }
`

/**
 * __useStaleIdsSubscription__
 *
 * To run a query within a React component, call `useStaleIdsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStaleIdsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaleIdsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useStaleIdsSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<StaleIdsSubscription, StaleIdsSubscriptionVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<StaleIdsSubscription, StaleIdsSubscriptionVariables>(StaleIdsDocument, options)
}
export type StaleIdsSubscriptionHookResult = ReturnType<typeof useStaleIdsSubscription>
export type StaleIdsSubscriptionResult = Apollo.SubscriptionResult<StaleIdsSubscription>
